<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-358.463 253.847-584.615l32.615-32.615L480-423.076l193.538-193.539L706.153-584 480-358.463Z"/></svg>
</template>
